/// Menu
import MetisMenu from "metismenujs";
import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { withRouter } from "react-router";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import socketIOClient from "socket.io-client";

const notifyTopRight = () => {
  toast.success("✅ Top Right !", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

///
// import drump from "../../../images/card/drump.png";


class MM extends React.Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }

  constructor(props) {
    super(props);
    this.state = {
      cameraModal: false,
    };
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }

  setCameraModal = (flag) => {
    this.setState({
      cameraModal: flag,
    });
  };
  render() {
    return (
      <div className="mm-wrapper menu-ul-border" style={{ backgroundColor: "#FE634E" }}>
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newEvent: false,
      eventType: "",
      eventData: [],
      titleCounter: 0,
      mainTitle: document.title,
      newSmsEvent: false,
      eventSmsData: [],
      newNoteEvent: false,
      eventNoteData: [],
      noteCount: 0,
      smsCount: 0,
      ticketCount: 0
    };
  }

  onCloseEventPopup = () => {
    this.setState({
      newEvent: false,
      eventData: [],
      titleCounter: 0,
    })
    document.title = this.state.mainTitle
  }

  onCloseSmsEventPopup = () => {
    this.setState({
      newSmsEvent: false,
      eventSmsData: [],
      titleCounter: 0,
    })
    document.title = this.state.mainTitle
  }

  onCloseNoteEventPopup = () => {
    this.setState({
      newNoteEvent: false,
      eventNoteData: [],
      titleCounter: 0,
    })
    document.title = this.state.mainTitle
  }

  onClickTicket(ticketId) {
    this.setState({
      newEvent: false,
      eventData: [],
      titleCounter: 0
    })
    document.title = this.state.mainTitle
    // this.props.history.push(`/ticket/${ticketId}`)
    window.location.href = process.env.REACT_APP_APP_URL + "ticket/" + ticketId
  }

  onClickTicketSms(threadId) {
    this.setState({
      newSmsEvent: false,
      eventSmsData: [],
      titleCounter: 0
    })
    document.title = this.state.mainTitle
    // this.props.history.push(`/sms/${threadId}`)
    window.location.href = process.env.REACT_APP_APP_URL + "sms/" + threadId
  }

  onClickNote() {
    this.setState({
      newNoteEvent: false,
      eventNoteData: [],
      titleCounter: 0
    })
    document.title = this.state.mainTitle
    this.props.history.push(`/note-list`)
    window.location.href = process.env.REACT_APP_APP_URL + "note-list"
  }

  playNotificationSound = () => {
    let audio = new Audio(process.env.REACT_APP_API_URL + "/public/notificatioNew.mp3");
    audio.play();
  }
  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }

    btn.addEventListener("click", toggleFunc);

    const socket = socketIOClient(process.env.REACT_APP_API_URL, { transports: ['websocket'] });
    socket.on('connect', function () {
      console.log("TicketReplyEvent Connected to WS server");
    });

    // const socket = socketIOClient(process.env.REACT_APP_API_URL, {transports: ['websocket']});

    socket.on("TicketReplyEvent", data => {
      if (data && data.type && data.ticketId) {
        if (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) {
          let counter = this.state.titleCounter + 1
          document.title = `(${counter}) ${this.state.mainTitle}`;
          this.playNotificationSound();
          this.setState(prevState => ({
            eventData: [...prevState.eventData, data],
            newEvent: true,
            titleCounter: counter
          }))
        }
      }
    });

    socket.on("SmsReplyEvent", data => {
      if (data && data.type && data.threadId) {
        if (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) {
          let counter = this.state.titleCounter + 1
          document.title = `(${counter}) ${this.state.mainTitle}`;
          this.playNotificationSound();
          this.setState(prevState => ({
            eventSmsData: [...prevState.eventSmsData, data],
            newSmsEvent: true,
            titleCounter: counter
          }))
        }
      }
    });

    socket.on("NoteEvent", data => {
      console.log(data)
      if (data && data.type && data.noteId && data.userIds) {
        if (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) {
          console.log(localStorage.getItem("userId"))
          console.log(parseInt(localStorage.getItem("userId")))
          console.log(data.userIds.includes(parseInt(localStorage.getItem("userId"))))
          if (data.userIds.includes(parseInt(localStorage.getItem("userId")))) {
            let counter = this.state.titleCounter + 1
            document.title = `(${counter}) ${this.state.mainTitle}`;
            this.playNotificationSound();
            this.setState(prevState => ({
              eventNoteData: [...prevState.eventNoteData, data],
              newNoteEvent: true,
              titleCounter: counter
            }))
          }
        }
      }
    });

    socket.on("unreadCountEvent", data => {
      console.log("dataaaaaaaaaaaaaaaaa", data)
      if (data && data.type && data.role && data.userId) {
        if (data.type == 'unRead' && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
          if (data.userId == parseInt(localStorage.getItem("userId"))) {
            if (data.notCount && data.notCount[0]) {
              console.log(data.notCount)
              if (data.notCount[0].user_id == parseInt(localStorage.getItem("userId"))) {
                // this.setState({
                //   noteCount: data.notCount[0].unreadNoteCount
                // })
                localStorage.setItem('unreadNoteCount', data.smsCount[0].unreadNoteCount)
              }
            } else {
              this.setState({ noteCount: 0 })
              localStorage.setItem('unreadNoteCount', 0)
            }
          }
        }

        if (data.type == 'unRead' && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
          if (data.smsCount && data.smsCount[0] && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
            // this.setState({
            //   smsCount: data.smsCount[0].unreadSmsCount
            // })
            localStorage.setItem('unreadSmsCount', data.smsCount[0].unreadSmsCount)
          } else {
            // this.setState({ smsCount: 0 })
            localStorage.setItem('unreadSmsCount', 0)
          }
        }

        if (data.type == 'unRead' && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
          if (data.contactCount && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
            // this.setState({
            //   smsCount: data.smsCount[0].unreadSmsCount
            // })
            localStorage.setItem('unreadContactCount', data.contactCount)
          } else {
            // this.setState({ smsCount: 0 })
            localStorage.setItem('unreadContactCount', 0)
          }
        }

        if (data.type == 'unRead' && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
          if (data.customerCount && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
            // this.setState({
            //   smsCount: data.smsCount[0].unreadSmsCount
            // })
            localStorage.setItem('unreadCustomerCount', data.customerCount)
          } else {
            // this.setState({ smsCount: 0 })
            localStorage.setItem('unreadCustomerCount', 0)
          }
        }


        if (data.type == 'customerUnRead' && (localStorage.getItem("userType") == 3 || localStorage.getItem("userType") == 4)) {
          if (data.ticketCount && data.ticketCount[0]) {
            // this.setState({
            //   ticketCount: data.ticketCount[0].unreadTicketCount
            // })
            localStorage.setItem('unreadTicketCount', data.ticketCount[0].unreadTicketCount)
          } else {
            // this.setState({ ticketCount: 0 })
            localStorage.setItem('unreadTicketCount', 0)
          }
        }

        if (data.type == 'unRead' && (localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2)) {
          if (data.ticketCount && data.ticketCount[0]) {
            // this.setState({
            //   ticketCount: data.ticketCount[0].unreadTicketCount
            // })
            localStorage.setItem('unreadTicketCount', data.ticketCount[0].unreadTicketCount)
          } else {
            // this.setState({ ticketCount: 0 })
            localStorage.setItem('unreadTicketCount', 0)
          }
        }

      }
    });
  }

  render() {

    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 2] == "ticket" || path[path.length - 2] == "sms" ? path[path.length - 2] : path[path.length - 1];
    /// Active menu
    let sideMenu = ["", "ticket-list", "sms-list", "ticket", "sms", "contact-list", "note-list"];

    return (
      <div className="deznav" style={{ backgroundColor: "#3D455A" }}>
        <PerfectScrollbar className="deznav-scroll">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <Modal className="modal fade" show={this.state.newEvent}>
            <div className="">
              <div className="modal-header">
                <h5 className="modal-title">New Reply Ticket</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => this.onCloseEventPopup()}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{ textAlign: "center" }}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group">

                        {this.state.eventData.map(
                          (item, i) => {
                            return (
                              <div onClick={() => this.onClickTicket(item.ticketId)}>
                                <strong style={{ cursor: "pointer", color: "black" }}>Go To TKT{item.ticketId}</strong>
                                <br />
                                <br />
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <Modal className="modal fade" show={this.state.newSmsEvent}>
            <div className="">
              <div className="modal-header">
                <h5 className="modal-title">New Reply SMS</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => this.onCloseSmsEventPopup()}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{ textAlign: "center" }}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group">

                        {this.state.eventSmsData.map(
                          (item, i) => {
                            return (
                              <div onClick={() => this.onClickTicketSms(item.threadId)}>
                                <strong style={{ cursor: "pointer", color: "black" }}>Go To BGSMS{item.threadId}</strong>
                                <br />
                                <br />
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <Modal className="modal fade" show={this.state.newNoteEvent}>
            <div className="">
              <div className="modal-header">
                <h5 className="modal-title">New Notes</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => this.onCloseNoteEventPopup()}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{ textAlign: "center" }}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group">

                        {this.state.eventNoteData.map(
                          (item, i) => {
                            return (
                              <div onClick={() => this.onClickNote()}>
                                <strong style={{ cursor: "pointer", color: "black" }}>{item.type == 'noteUpdate' ? "Updated Note: Please Read" : "New Note: Please Read"}</strong>
                                <br />
                                <br />
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <MM className="metismenu" id="menu">
            <li className={`${!sideMenu.includes(path) ? "mm-active menu-li-border" : "menu-li-border"}`}>
              <Link className="has-arrow ai-icon menuText" to="#" aria-expanded="false">
                <i className="flaticon-381-networking"></i>
                <span className="nav-text menu-name">Ticket ( {localStorage.getItem("unreadTicketCount") ? localStorage.getItem("unreadTicketCount") : 0} )</span>
              </Link>
              <ul aria-expanded="false">
                <li className="subMenuLi" style={{ borderRadius: "1.25rem", backgroundColor: "#3D455A", border: "1px solid #ffffff !important" }}>
                  <Link
                    className={`${path == "" || path == "ticket-list" ? "mm-active" : ""}`}
                    to="/ticket-list"
                    style={{ color: "white" }}
                  >
                    Ticket List
                  </Link>
                </li>
              </ul>
            </li>
            {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? <li className={`${!sideMenu.includes(path) ? "mm-active menu-li-border" : "menu-li-border"}`}>
              <Link className="has-arrow ai-icon menuText" to="#" aria-expanded="false">
                <i className="flaticon-381-smartphone-5"></i>
                <span className="nav-text menu-name">SMS ( {localStorage.getItem("unreadSmsCount") ? localStorage.getItem("unreadSmsCount") : 0} )</span>
              </Link>
              <ul aria-expanded="false">
                <li className="subMenuLi" style={{ borderRadius: "1.25rem", backgroundColor: "#3D455A", border: "1px solid #ffffff !important" }}>
                  <Link
                    className={`${path == "" || path == "sms-list" ? "mm-active" : ""}`}
                    to="/sms-list"
                    style={{ color: "white" }}
                  >
                    SMS List
                  </Link>
                </li>
              </ul>
            </li> : ""}
            {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? <li className={`${!sideMenu.includes(path) ? "mm-active menu-li-border" : "menu-li-border"}`}>
              <Link className="has-arrow ai-icon menuText" to="#" aria-expanded="false">
                <i className="flaticon-381-smartphone-2"></i>
                <span className="nav-text menu-name">Contact ( { localStorage.getItem("unreadContactCount") ? localStorage.getItem("unreadContactCount") : 0 } )</span>
              </Link>
              <ul aria-expanded="false">
                <li className="subMenuLi" style={{ borderRadius: "1.25rem", backgroundColor: "#3D455A", border: "1px solid #ffffff !important" }}>
                  <Link
                    className={`${path == "" || path == "contact-list" ? "mm-active" : ""}`}
                    to="/contact-list"
                    style={{ color: "white" }}
                  >
                    Contact List
                  </Link>
                </li>
              </ul>
            </li> : ""}
            {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? <li className={`${!sideMenu.includes(path) ? "mm-active menu-li-border" : "menu-li-border"}`}>
              <Link className="has-arrow ai-icon menuText" to="#" aria-expanded="false">
                <i className="flaticon-381-user-4"></i>
                <span className="nav-text menu-name">Customer ( { localStorage.getItem("unreadCustomerCount") ? localStorage.getItem("unreadCustomerCount") : 0 } )</span>
              </Link>
              <ul aria-expanded="false">
                <li className="subMenuLi" style={{ borderRadius: "1.25rem", backgroundColor: "#3D455A", border: "1px solid #ffffff !important" }}>
                  <Link
                    className={`${path == "" || path == "customer-list" ? "mm-active" : ""}`}
                    to="/customer-list"
                    style={{ color: "white" }}
                  >
                    Customer List
                  </Link>
                </li>
              </ul>
            </li> : ""}
            {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? <li className={`${!sideMenu.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon menuText" to="#" aria-expanded="false">
                <i className="flaticon-381-note"></i>
                <span className="nav-text menu-name">Notes ( {localStorage.getItem("unreadNoteCount") ? localStorage.getItem("unreadNoteCount") : 0} )</span>
              </Link>
              <ul aria-expanded="false">
                <li className="subMenuLi" style={{ borderRadius: "1.25rem", backgroundColor: "#3D455A", border: "1px solid #ffffff !important" }}>
                  <Link
                    className={`${path == "" || path == "note-list" ? "mm-active" : ""}`}
                    to="/note-list"
                    style={{ color: "white" }}
                  >
                    BG Notes
                  </Link>
                </li>
              </ul>
            </li> : ""}
          </MM>
        </PerfectScrollbar>
      </div>
    );
  }
}

export default withRouter(SideBar);
